import { render, staticRenderFns } from "./CompanyAwayDetailPageTable.vue?vue&type=template&id=5197d3e8&scoped=true&"
import script from "./CompanyAwayDetailPageTable.vue?vue&type=script&lang=js&"
export * from "./CompanyAwayDetailPageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5197d3e8",
  null
  
)

export default component.exports